import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a81844b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Nyanställda", -1))
const _hoisted_2 = {
  class: "modal fade",
  id: "deleteNewEmployeeModal",
  tabindex: "-1",
  "aria-labelledby": "showDeleteNewEmployeeModalButton",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Ta bort nyanställd?"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Stäng"
  })
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  "aria-label": "Avbryt"
}, "Avbryt", -1))
const _hoisted_12 = {
  class: "table-responsive",
  style: {"max-height":"250px"}
}
const _hoisted_13 = { class: "table table-striped table-hover" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-center"
}, "Det finns inga nyanställda inlagda", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = { autocomplete: "off" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "row mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-firstName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Förnamn:", -1))
const _hoisted_27 = { class: "col-md-4 col-xs-12" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-lastName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Efternamn:", -1))
const _hoisted_29 = { class: "col-md-4 col-xs-12" }
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-personalIdentityNumber",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Personnummer:", -1))
const _hoisted_32 = { class: "col-md-10 col-xs-12" }
const _hoisted_33 = { class: "row mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-address",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Adress:", -1))
const _hoisted_35 = { class: "col-md-10 col-xs-12" }
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-address2",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Adress 2:", -1))
const _hoisted_38 = { class: "col-md-10 col-xs-12" }
const _hoisted_39 = { class: "row mb-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-postalCode",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Postnummer:", -1))
const _hoisted_41 = { class: "col-md-4 col-xs-12" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-city",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Ort:", -1))
const _hoisted_43 = { class: "col-md-4 col-xs-12" }
const _hoisted_44 = { class: "row mb-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-phone",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Hemtelefon:", -1))
const _hoisted_46 = { class: "col-md-4 col-xs-12" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-mobile",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Mobiltelefon:", -1))
const _hoisted_48 = { class: "col-md-4 col-xs-12" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_50 = { class: "row mb-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativeName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anhörig:", -1))
const _hoisted_52 = { class: "col-md-4 col-xs-12" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativeRelation",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Relation:", -1))
const _hoisted_54 = { class: "col-md-4 col-xs-12" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "row mb-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativePhone",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anhörig telefon:", -1))
const _hoisted_58 = { class: "col-md-10 col-xs-12" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_60 = { class: "row mb-3" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-bankClearing",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Clearingnummer:", -1))
const _hoisted_62 = { class: "col-md-4 col-xs-12" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-bankAccount",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Bankkonto:", -1))
const _hoisted_64 = { class: "col-md-4 col-xs-12" }
const _hoisted_65 = { class: "row mb-3" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-roleId",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Kampanj:", -1))
const _hoisted_67 = { class: "col-md-10 col-xs-12" }
const _hoisted_68 = ["value", "disabled"]
const _hoisted_69 = { class: "row mb-3" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-employmentDate",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anställningsdatum:", -1))
const _hoisted_71 = { class: "col-md-4 col-xs-12" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-employmentForm",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anställningsform:", -1))
const _hoisted_73 = { class: "col-md-4 col-xs-12" }
const _hoisted_74 = ["value"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_76 = { class: "row mb-3" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-info",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Övrig info:", -1))
const _hoisted_78 = { class: "col-md-10 col-xs-12" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_80 = { class: "row mb-3" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-createdBy",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Post skapad av:", -1))
const _hoisted_82 = { class: "col-md-4 col-xs-12" }
const _hoisted_83 = ["value"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-createdAt",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Post skapad:", -1))
const _hoisted_85 = { class: "col-md-4 col-xs-12" }
const _hoisted_86 = ["value"]
const _hoisted_87 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-accountsCreatedBy",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Konton skapade av:", -1))
const _hoisted_89 = { class: "col-md-4 col-xs-12" }
const _hoisted_90 = ["value"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-accountsCreatedAt",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Konton skapade:", -1))
const _hoisted_92 = { class: "col-md-4 col-xs-12" }
const _hoisted_93 = ["value"]
const _hoisted_94 = {
  key: 1,
  class: "row"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-success alert-dismissible fade show",
    role: "alert"
  }, [
    /*#__PURE__*/_createTextVNode(" Uppgifterna sparades. "),
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn-close",
      "data-bs-dismiss": "alert",
      "aria-label": "Close"
    })
  ])
], -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = { class: "row mb-3" }
const _hoisted_98 = { class: "col d-grid" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col d-grid" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_messages = _resolveComponent("messages")!
  const _component_FormInputPersonalIdentityNumber = _resolveComponent("FormInputPersonalIdentityNumber")!
  const _component_FormInputPostalCode = _resolveComponent("FormInputPostalCode")!
  const _component_FormInputPhoneNumber = _resolveComponent("FormInputPhoneNumber")!
  const _component_FormInputDate = _resolveComponent("FormInputDate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "float-end btn btn-outline-dark",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
    }, [
      _createVNode(_component_fa_icon, { icon: "sync-alt" })
    ]),
    _hoisted_1,
    _createVNode(_component_messages, { ref: "errorHandler" }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(" Vill du verkligen ta bort "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.newEmployeeToDelete?.fullName), 1),
            _createTextVNode(" (kampanj " + _toDisplayString(_ctx.newEmployeeToDelete?.campaign?.abbreviation) + ")? ", 1),
            (_ctx.deletingNewEmployee)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_fa_icon, {
                      icon: "spinner",
                      spin: _ctx.deletingNewEmployee
                    }, null, 8, ["spin"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_messages, { ref: "deleteNewEmployeeErrorHandler" }, null, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.deleteNewEmployee(_ctx.newEmployeeToDelete)), ["prevent"]))
            }, " Ta bort ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("table", _hoisted_13, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('firstName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'firstName',
              reverse: _ctx.sortReverse,
            }])
            }, " Förnamn ", 2),
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('lastName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'lastName',
              reverse: _ctx.sortReverse,
            }])
            }, " Efternamn ", 2),
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('campaignName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'campaignName',
              reverse: _ctx.sortReverse,
            }])
            }, " Kampanj ", 2),
            _hoisted_14
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingNewEmployees)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                _createElementVNode("td", _hoisted_16, [
                  _createVNode(_component_fa_icon, {
                    icon: "spinner",
                    spin: ""
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loadingNewEmployees && _ctx.newEmployees.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newEmployees, (e) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: e.id,
              onClick: ($event: any) => (_ctx.selectNewEmployee(e)),
              role: "button",
              title: `ID: ${e.id}`
            }, [
              _createElementVNode("td", null, _toDisplayString(e.firstName), 1),
              _createElementVNode("td", null, _toDisplayString(e.lastName), 1),
              _createElementVNode("td", null, _toDisplayString(e.campaign.abbreviation), 1),
              _createElementVNode("td", _hoisted_21, [
                _createVNode(_component_fa_icon, { icon: "pen-to-square" })
              ])
            ], 8, _hoisted_20))
          }), 128))
        ])
      ])
    ]),
    (_ctx.newEmployee)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_22,
          _createElementVNode("form", _hoisted_23, [
            _createElementVNode("fieldset", {
              disabled: 
          _ctx.loadingCampaigns ||
          _ctx.loadingEmploymentForms ||
          _ctx.loadingRelationTypes ||
          _ctx.newEmployee?.accountsCreatedAt != undefined
        
            }, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-firstName",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newEmployee.firstName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.firstName]
                  ])
                ]),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-lastName",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newEmployee.lastName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.lastName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_FormInputPersonalIdentityNumber, {
                    modelValue: _ctx.newEmployee.personalIdentityNumber,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newEmployee.personalIdentityNumber) = $event)),
                    id: "form-personalIdentityNumber"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-address",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newEmployee.address) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.address]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-address2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newEmployee.address2) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.address2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_FormInputPostalCode, {
                    modelValue: _ctx.newEmployee.postalCode,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newEmployee.postalCode) = $event)),
                    id: "form-postalCode"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-city",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newEmployee.city) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.city]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_FormInputPhoneNumber, {
                    modelValue: _ctx.newEmployee.phoneHome,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newEmployee.phoneHome) = $event)),
                    id: "form-phone"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_FormInputPhoneNumber, {
                    modelValue: _ctx.newEmployee.phoneMobile,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newEmployee.phoneMobile) = $event)),
                    id: "form-mobile"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-relativeName",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newEmployee.relativeName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.relativeName]
                  ])
                ]),
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _withDirectives(_createElementVNode("select", {
                    id: "form-relativeRelation",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newEmployee.relativeRelation) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationTypes, (rt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: rt.id,
                        value: rt
                      }, _toDisplayString(rt.name), 9, _hoisted_55))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newEmployee.relativeRelation]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_FormInputPhoneNumber, {
                    modelValue: _ctx.newEmployee.relativePhone,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newEmployee.relativePhone) = $event)),
                    id: "form-relativePhone"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-bankClearing",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newEmployee.bankClearing) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.bankClearing]
                  ])
                ]),
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-bankAccount",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newEmployee.bankAccount) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.bankAccount]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, [
                  _withDirectives(_createElementVNode("select", {
                    id: "form-roleId",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newEmployee.campaign) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (c) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: c.id,
                        value: c,
                        disabled: !c.active
                      }, _toDisplayString(c.id) + " : " + _toDisplayString(c.name), 9, _hoisted_68))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newEmployee.campaign]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_FormInputDate, {
                    modelValue: _ctx.newEmployee.employmentDate,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newEmployee.employmentDate) = $event)),
                    id: "form-employmentDate"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_72,
                _createElementVNode("div", _hoisted_73, [
                  _withDirectives(_createElementVNode("select", {
                    id: "form-employmentForm",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newEmployee.employmentForm) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employmentForms, (ef) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: ef.id,
                        value: ef
                      }, _toDisplayString(ef.name), 9, _hoisted_74))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newEmployee.employmentForm]
                  ])
                ])
              ]),
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createElementVNode("div", _hoisted_78, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    id: "form-info",
                    rows: "3",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newEmployee.info) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newEmployee.info]
                  ])
                ])
              ]),
              _hoisted_79,
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("input", {
                    type: "text",
                    readonly: "",
                    class: "form-control-plaintext",
                    id: "form-createdBy",
                    value: _ctx.newEmployee.createdBy?.fullName
                  }, null, 8, _hoisted_83)
                ]),
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("input", {
                    type: "text",
                    value: _ctx.fmt.fmtDateTime(_ctx.newEmployee.createdAt),
                    id: "form-createdAt",
                    readonly: "",
                    class: "form-control-plaintext"
                  }, null, 8, _hoisted_86)
                ])
              ]),
              (_ctx.newEmployee.accountsCreatedAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("input", {
                        type: "text",
                        readonly: "",
                        class: "form-control-plaintext",
                        id: "form-accountsCreatedBy",
                        value: _ctx.newEmployee.accountsCreatedBy?.fullName
                      }, null, 8, _hoisted_90)
                    ]),
                    _hoisted_91,
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("input", {
                        type: "text",
                        value: _ctx.fmt.fmtDateTime(_ctx.newEmployee.accountsCreatedAt),
                        id: "form-accountsCreatedAt",
                        readonly: "",
                        class: "form-control-plaintext"
                      }, null, 8, _hoisted_93)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_messages, { ref: "saveNewEmployeeErrorHandler" }, null, 512),
              (_ctx.saveNewEmployeeSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.updateNewEmployee()), ["prevent"])),
                    disabled: _ctx.deletingNewEmployee || _ctx.savingNewEmployee
                  }, [
                    (!_ctx.savingNewEmployee)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_100, "Spara"))
                      : (_openBlock(), _createBlock(_component_fa_icon, {
                          key: 1,
                          icon: "spinner"
                        }))
                  ], 8, _hoisted_99)
                ])
              ]),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-danger",
                    onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.showDeleteNewEmployeeModal(_ctx.newEmployee)), ["prevent"])),
                    disabled: _ctx.deletingNewEmployee || _ctx.savingNewEmployee
                  }, [
                    (!_ctx.deletingNewEmployee)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_104, "Ta bort"))
                      : (_openBlock(), _createBlock(_component_fa_icon, {
                          key: 1,
                          icon: "spinner"
                        }))
                  ], 8, _hoisted_103)
                ])
              ])
            ], 8, _hoisted_24)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}